import React from 'react';
import {withI18n} from 'spa/Components/Context';

import Typography, { TypeVariants } from '@urbanmassage/component-library/lib/Typography/Typography';
import StarRatingGroup from '@urbanmassage/component-library/lib/StarRatingGroup/StarRatingGroup';
import { IconSizes } from '@urbanmassage/component-library/lib/Theme/b2c-theme';
import ProgressiveImage from 'spa/Components/ProgressiveImage';

import './app-install-banner-login.less';

const AppInstallBannerLogin = (props, {i18n}) => (
  <div className="app-install-banner-login__wrapper">
    <div className="app-install-banner-login__inner">
      <div className="app-install-banner-login__phones-img-wrapper">
        <ProgressiveImage
          lowResImg="https://res.cloudinary.com/huxr6hrje/image/upload/f_auto,w_190/v1700149345/b2c-art/app-download-banners/app-install-phones.png"
          highResImg="https://res.cloudinary.com/huxr6hrje/image/upload/f_auto,w_380/v1700149345/b2c-art/app-download-banners/app-install-phones.png"
          altText="App Install Banner Login"
        />
      </div>
      <Typography variant={TypeVariants.h1} theme="white" className="app-install-banner-login__title">
        <span className="app-install-banner-login__title-line-1">
          {i18n._x('Booking’s better', 'App Install Banner Login')}
        </span>
        <span className="app-install-banner-login__title-line-2">
          {i18n._x('with the app', 'App Install Banner Login')}
        </span>
      </Typography>
      <ul className="app-install-banner-login__list">
        <li>
          <Typography component="span" variant={TypeVariants.bodyLarge} theme="white">{i18n._x('Get live appointment updates', 'App Install Banner Login')}</Typography>
        </li>
        <li>
          <Typography component="span" variant={TypeVariants.bodyLarge} theme="white">{i18n._x('Access exclusive offers', 'App Install Banner Login')}</Typography>
        </li>
        <li>
          <Typography component="span" variant={TypeVariants.bodyLarge} theme="white">{i18n._x('Chat directly with your pro', 'App Install Banner Login')}</Typography>
        </li>
      </ul>
      <div className="app-install-banner-login__qr-img-wrapper">
        <ProgressiveImage
          lowResImg="https://res.cloudinary.com/huxr6hrje/image/upload/f_auto,w_36/v1700149345/b2c-art/app-download-banners/app-install-qr.png"
          highResImg="https://res.cloudinary.com/huxr6hrje/image/upload/f_auto,w_144/v1700149345/b2c-art/app-download-banners/app-install-qr.png"
          altText={i18n._x('Download the app, for iOS and Android', 'App Install Banner Login')}
        />
        <Typography variant={TypeVariants.bodySmall} theme="white">{i18n._x('Download the app, for iOS and Android', 'App Install Banner Login')}</Typography>
      </div>
      <div className="app-install-banner-login__reviews-wrapper">
        <div className="app-install-banner-login__reviews-stars">
          <StarRatingGroup totalStars={5} activeStars={5} iconSize={IconSizes.small} />
        </div>
        <Typography variant={TypeVariants.bodySmall} theme="white">{i18n._x('Over 10,000 5-star reviews', 'App Install Banner Login')}</Typography>
      </div>
    </div>
  </div>
);

export default withI18n(AppInstallBannerLogin);



// WEBPACK FOOTER //
// ./spa/Pages/AppInstallBanner/AppInstallBannerLogin.jsx